import { useState, useEffect } from "react";
import DynamicBanner from "../../include/DynamicBanner";
import Introduction from "./Partials/Introduction";
import Composition from "./Partials/Composition";
import LinkSection from "./Partials/LinkSection";
import StickyNav from "../CommitteeCouncil/Partials/StickyNav";
import api from "../../../../api"; // Your axios instance
import "./IhecFaculty.css"; // Your CSS file

const IhecFaculty = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Adjust this endpoint if needed based on your API routes
        const response = await api.get("/api/sitepages/academic/ihec-faculty");
        if (response.data.status) {
          setData(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <div className="text-center py-5">Loading...</div>;
  if (!data) return <div className="text-center py-5">No Data Found</div>;

  // Handle Banner Image path logic (MULTIPLE images)
  const bannerImage = data.banner_section?.desktop_images?.map(
    (img) => `/${img}`,
  ) || ["/assets/images/default-banner.webp"];

  const bannerImageMobile = data.banner_section?.mobile_images?.map(
    (img) => `/${img}`,
  ) || ["/assets/images/default-banner.webp"];

  const bannerTitle = data.banner_section?.heading || "IHEC Faculty";

  return (
    <div className="ihecfaculty-section">
      <DynamicBanner
        title={bannerTitle}
        bgImage={bannerImage}
        bgImageMobile={bannerImageMobile}
      />
      <StickyNav />
      {/* Section 2: Content (Introduction/Functions) */}
      <Introduction
        sectionData={data.section_2}
        baseUrl={process.env.REACT_APP_API_URL}
      />

      {/* Section 3: Composition (Dynamic Table) */}
      <Composition sectionData={data.section_3} />

      {/* Section 4: Links/PDFs */}
      <LinkSection
        sectionData={data.section_4}
        baseUrl={process.env.REACT_APP_API_URL}
      />
    </div>
  );
};

export default IhecFaculty;
